import { render, staticRenderFns } from "./ModalContentBulkAddVirtualMembers.vue?vue&type=template&id=581a63a0&"
import script from "./ModalContentBulkAddVirtualMembers.vue?vue&type=script&lang=js&"
export * from "./ModalContentBulkAddVirtualMembers.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentBulkAddVirtualMembers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports